import { use } from "react";
import { EditorModeContext, type EditorModeContextValue } from "./EditorModeProvider";

export function useEditorMode(): EditorModeContextValue {
  const context = use(EditorModeContext);
  if (!context) {
    throw new Error("useEditorMode must be used within an EditorModeProvider");
  }
  return context;
}
